import styled, { css } from 'styled-components'

export const ButtonWrapper = styled.button<{ $isMobile?: boolean }>`
  position: relative;
  width: 100%;
  height: ${({ $isMobile }) => ($isMobile ? '32px' : '40px')};
  padding: var(--space-100) var(--space-400);
  padding-right: ${({ $isMobile }) => ($isMobile ? 'var(--space-400)' : '80px')};
  background: transparent;
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-brand);
  text-align: left;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: var(--input-border-hover);
  }

  &:focus {
    outline: none;
    border-color: var(--input-border-active);
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-300);
`

export const SearchIconWrapper = styled.div`
  display: flex;
  align-items: center;
  color: var(--icon-secondary);
`

export const PlaceholderText = styled.span<{ $isMobile?: boolean }>`
  color: var(--text-secondary);

  height: 100%;

  font-family: var(--font-family-body);
  font-size: ${({ $isMobile }) => ($isMobile ? 'var(--font-size-300)' : 'var(--font-size-400)')};
  font-weight: var(--font-weight-regular);
  line-height: ${({ $isMobile }) =>
    $isMobile
      ? 'var(--font-line-height-300)'
      : 'var(--font-line-height-400)'}; /* 150% desktop, 142.857% mobile */
  letter-spacing: var(--font-letter-spacing-normal);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const KeyboardBadgeWrapper = styled.div`
  position: absolute;
  right: var(--space-400);
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: var(--space-50);
  pointer-events: none;
`

export const Key = styled.kbd<{ size?: 'small' | 'large' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 var(--space-100);
  background: var(--bg-secondary);
  border-radius: var(--radius-brand);
  text-align: center;
  color: var(--text-secondary);

  font-family: var(--font-family-body);
  font-size: var(--font-size-200);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-200); /* 133.333% */
  letter-spacing: var(--font-letter-spacing-looser);

  ${({ size }) =>
    size === 'large' &&
    css`
      font-size: var(--font-size-300);
      font-style: normal;
      font-weight: var(--font-weight-regular);
      line-height: var(--font-line-height-300); /* 142.857% */
      letter-spacing: var(--font-letter-spacing-loose);
    `}
`
